export default __webpack_public_path__ + "static/media/MtCook.853915ed.jpg";